import React from 'react';
import project1 from '../../../images/project-1.png'
import project01 from '../../../images/project-1.1.png'
import project02 from '../../../images/project-1.2.png'
import project03 from '../../../images/project-1.3.png'
import project2 from '../../../images/project-2.png'
import project04 from '../../../images/project-2.1.png'
import project05 from '../../../images/project-2.2.png'
import project06 from '../../../images/project-2.3.png'
import project3 from '../../../images/project-3.png'
import project07 from '../../../images/project-3.1.png'
import project08 from '../../../images/project-3.2.png'
import project09 from '../../../images/project-3.3.png'
import project4 from '../../../images/project-4.png'
import project10 from '../../../images/project-4.1.png'
import project11 from '../../../images/project-4.2.png'
import project12 from '../../../images/project-4.3.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt, } from '@fortawesome/free-solid-svg-icons'


const Projects = () => {
    const icon = <FontAwesomeIcon icon={faExternalLinkAlt} />


    return (
        <div id='projects'>
            <div className="container pb-5 mb-5">
                <h2 className="mb-4 text-center theme-color fw-bold  p-3">My Recent Project</h2>

                <div className="d-flex flex-column flex-lg-row align-items-center shadow-lg mb-5 mx-4">
                    <div className="col-lg-6 col-12">
                        <div className='p-3 p-lg-5'>
                            <img src={project1} className="img-fluid" alt="" />
                            <div>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div>
                                            <img src={project01} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project02} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project03} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 text-start p-3">
                        <h4 className="text-color">Helping Hand Website <small style={{ fontSize: "16px", color: "white" }}>(Team Work)</small></h4>
                        <small>January 2022</small>
                        <ul className='my-3' style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>
                            <li>Allowing customers to create an account, browse and buy products, cancel orders and add reviews.</li>
                            <li>Separated user interface and functionality access for both admin and user from their dashboard.</li>
                            <li>Admin has the ability to add new products, remove existing products and orders, update shipping status
                                and create a new admin account.</li>
                        </ul>


                        <div className="row row-cols-3 row-cols-lg-6 g-3 g-lg-2 my-3">
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-4'>#React</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-4'>#React</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Node.Js</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools'>#MongoDB</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Firebase</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Heroku</span>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <a target="_blank" href="https://helping-hand-team-project.web.app/" className='text-decoration-none text-light me-lg-5 me-5'><span className='text-color me-1'>{icon}</span> Live Site</a>
                            <a target="_blank" href="https://github.com/lutfor779/Helping-Hand" className='text-decoration-none text-light me-lg-5 me-4'><span className='text-color me-1'>{icon}</span> Client Code</a>
                            <a target="_blank" href="https://github.com/lutfor779/Helping-Hand-Server" className='text-decoration-none text-light me-lg-5'><span className='text-color me-1'>{icon}</span> Server Code</a>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column flex-lg-row align-items-center shadow-lg mb-5 mx-4">
                    <div className="col-lg-6 col-12">
                        <div className='p-3 p-lg-5'>
                            <img src={project2} className="img-fluid" alt="" />
                            <div>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div>
                                            <img src={project04} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project05} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project06} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 text-start p-3">
                        <h4 className="text-color">Home Moving Website</h4>
                        <small>December 2021</small>
                        <ul className='my-3' style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>
                            <li>Allowing customers to create an account, browse and buy products, cancel orders and add reviews.</li>
                            <li>Separated user interface and functionality access for both admin and user from their dashboard.</li>
                            <li>Admin has the ability to add new products, remove existing products and orders, update shipping status
                                and create a new admin account.</li>
                        </ul>


                        <div className="row row-cols-3 row-cols-lg-6 g-3 g-lg-2 my-3">
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-4'>#React</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Node.Js</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools'>#MongoDB</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Firebase</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Heroku</span>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <a target="_blank" href="https://moving-service-ca7db.web.app/" className='text-decoration-none text-light me-lg-5 me-5'><span className='text-color me-1'>{icon}</span> Live Site</a>
                            <a target="_blank" href="https://github.com/ihrimon/moving-service-client" className='text-decoration-none text-light me-lg-5 me-4'><span className='text-color me-1'>{icon}</span> Client Code</a>
                            <a target="_blank" href="https://github.com/ihrimon/moving-service-server" className='text-decoration-none text-light me-lg-5'><span className='text-color me-1'>{icon}</span> Server Code</a>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column flex-lg-row align-items-center shadow-lg mb-5 mx-4">
                    <div className="col-lg-6 col-12">
                        <div className='p-3 p-lg-5'>
                            <img src={project3} className="img-fluid" alt="" />
                            <div>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div>
                                            <img src={project07} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project08} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project09} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 text-start p-3">
                        <h4 className="text-color">Waves Photography Website</h4>
                        <small>November 2021</small>
                        <ul className='my-3' style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>
                            <li>Allowing customers to create an account, browse and buy products, cancel orders and add reviews.</li>
                            <li>Separated user interface and functionality access for both admin and user from their dashboard.</li>
                            <li>Admin has the ability to add new products, remove existing products and orders, update shipping status
                                and create a new admin account.</li>
                        </ul>


                        <div className="row row-cols-3 row-cols-lg-6 g-3 g-lg-2 my-3">
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-4'>#React</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Node.Js</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools'>#MongoDB</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Firebase</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Heroku</span>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <a target="_blank" href="https://waves-photography.web.app/" className='text-decoration-none text-light me-lg-5 me-5'><span className='text-color me-1'>{icon}</span> Live Site</a>
                            <a target="_blank" href="https://github.com/ihrimon/waves-photography-website" className='text-decoration-none text-light me-lg-5 me-4'><span className='text-color me-1'>{icon}</span> Client Code</a>
                            <a target="_blank" href="https://github.com/ihrimon/waves-photography-server-code" className='text-decoration-none text-light me-lg-5'><span className='text-color me-1'>{icon}</span> Server Code</a>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column flex-lg-row align-items-center shadow-lg mx-4">
                    <div className="col-lg-6 col-12">
                        <div className='p-3 p-lg-5'>
                            <img src={project4} className="img-fluid" alt="" />
                            <div>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div>
                                            <img src={project10} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project11} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <img src={project12} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 text-start p-3">
                        <h4 className="text-color">Wonder Travel Website</h4>
                        <small>October 2021</small>
                        <ul className='my-3' style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>
                            <li>Users can book any travel package and they can cancel their booking.</li>
                            <li>If the user is authenticated he/she can add packages that will be shown on the home page.</li>
                            <li>Implemented email-password and google authentication system using firebase.</li>
                        </ul>

                        <div className="row row-cols-3 row-cols-lg-6 g-3 g-lg-2 my-3">
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-4'>#React</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Node.Js</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools'>#MongoDB</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Firebase</span>
                            </div>
                            <div className="col my-2 mx-2">
                                <span className='rounded-3 tools px-3'>#Heroku</span>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <a target="_blank" href="https://wonder-travel-a6b6a.web.app/" className='text-decoration-none text-light me-lg-5 me-5'><span className='text-color me-1'>{icon}</span> Live Site</a>
                            <a target="_blank" href="https://github.com/ihrimon/wonder-travel-website" className='text-decoration-none text-light me-lg-5 me-4'><span className='text-color me-1'>{icon}</span> Client Code</a>
                            <a target="_blank" href="https://github.com/ihrimon/wonder-travel-server-code" className='text-decoration-none text-light me-lg-5'><span className='text-color me-1'>{icon}</span> Server Code</a>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    );
};

export default Projects;